import { GROUPS } from './../../../app.constants';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NotificationsService } from '@app/core/services';
import { HandlerService } from '@app/_services/handler.service';
import { Notification } from '@df/interfaces';

@Component({
    selector: 'app-profile-notifications',
    templateUrl: './profile-notifications.component.html',
    styleUrls: ['./profile-notifications.component.scss']
})
export class NotificationsComponent implements OnInit {
    notifications: Array<Notification> = [];
    isParent = false;
    withoutNotification = {
        event: { title: '', date: '' },
        notification: { description: '' }
    };

    constructor(
        private notificationsService: NotificationsService,
        private handlerService: HandlerService,
        private router: Router
    ) {}

    ngOnInit() {
        const profile = JSON.parse(localStorage.getItem('profile'));
        this.isParent = profile && profile.group && profile.group.name === GROUPS.PARENT;
        this.getCurrentUserNotifications();
        this.getWithoutNotification();
    }

    private getCurrentUserNotifications(): void {
        this.notificationsService.getCurrentUserNotifications().subscribe(resp => {
            this.notifications = resp.results;

            if (this.notifications.length === 1) {
                const firstNotification = this.notifications[0];
                this.showNotificationItem(firstNotification);
            }
        });
    }

    showNotificationItem(notification) {
        this.router.navigate([`/profile/notifications/${notification.id}`]).then();
    }

    private getWithoutNotification(): void {
        this.notificationsService.getWithoutNotification().subscribe(resp => {
            this.handlerService.checkErrors(resp);
            if (!resp.error) {
                this.withoutNotification = resp.data;
            }
        });
    }
}
